import React from "react";
import PerfilService from "../../services/PerfilService";
import CrudList from "../../components/forms/custom/CrudList";

export default class ListaPerfil extends CrudList {

    constructor(props) {
        super(props);

        this.state.crud = {
            service: PerfilService,
            labels: {
                title: 'Lista de Perfil(s)',
                btnNewRegister: 'Perfil',
            },
            keyItem: 'idPerfil',
            urlForm: '/CadPerfil',
            itensFilter: ["idPerfil", "nome"],
            searchFormSubmit: false
        };
    }

    componentDidMount() {
        super.componentDidMount();
    }

    componentWillUnmount() {
        super.componentWillUnmount();
    }

    getRenderHeader() {
        return (
            <>
                <th className="col-md-2 text-center d-none d-md-table-cell"> Código </th>
                <th className="col-md-10"> Nome </th>
                <th className="col-md"> Usuários </th>
                <th className="col-md text-center text-nowrap"> Bloqueia por Débito? </th>
                <th className="col-md text-center text-nowrap"> Perfil de Representante? </th>
            </>
        );
    }

    getRenderItem(item) {
        return (
            <>
                <td className="text-center d-none d-md-table-cell">{item.idPerfil}</td>
                <td>{item.nome}</td>
                <td className="text-center">{item.usuarios}</td>
                <td className="text-center">{Boolean(item.flBloqueiaDebito) ? <span className="badge bg-danger">SIM</span> : <span className="badge bg-primary">NÃO</span>}</td>
                <td className="text-center">{Boolean(item.flRepresentante) ? <span className="badge bg-success">SIM</span> : <span className="badge bg-secondary">NÃO</span>}</td>
            </>);
    }

    render() {
        return super.render();
    }
}